// @mui material components
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';

import Card from "@mui/material/Card";
// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
// Soft UI Dashboard React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import React, { useEffect, useState, useCallback, useRef  } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { apiurl } from "utils";
import Select2Field from 'components/Select2Field';
import { Grid } from '@mui/material';
import Loading from 'components/Loading';
import debounce from 'debounce';
import Swal from 'sweetalert2';
import {
  useSoftUIController
} from "context";
import { useTranslate } from "utils/i18n";







function ChangePassword() {
  const [loading, setLoading] = useState(false);
  const [controller] = useSoftUIController();
  const { user } = controller;
  const { t } = useTranslate();



  const formik = useFormik({
    initialValues: {
      userId: user?.userId,
      currentPassword: "",
      newPassword: ""
    },
    validationSchema: Yup.object({
      currentPassword: Yup.string().required(t("validation.current_password_required", "Mot de passe actuel est requis")),
      newPassword: Yup.string()
        .required(t("validation.new_password_required", "Nouveau mot de passe est requis"))
        .min(6, t("validation.password_min", "Le mot de passe doit comporter au moins 8 caractères"))
        .matches(/[a-z]/, t("validation.password_lowercase", "Le mot de passe doit contenir au moins une lettre minuscule ('a'-'z')"))
        .matches(/[A-Z]/, t("validation.password_uppercase", "Le mot de passe doit contenir au moins une lettre majuscule ('A'-'Z')"))
        .matches(/[^a-zA-Z0-9]/, t("validation.password_special", "Le mot de passe doit contenir au moins un caractère non alphanumérique"))
    }),
    onSubmit: async (values, {setSubmitting, resetForm}) => {
      try {
        console.log("Form submitted:", JSON.stringify(values));
        setLoading(true);
        const formData = new FormData();
        formData.append("userId", user?.userId);
        formData.append("currentPassword", values.currentPassword);
        formData.append("newPassword", values.newPassword);

        const response = await axios.post(apiurl + "Auth/changepass", formData, {
          headers: {
            "Authorization": `Bearer ${localStorage.getItem("tk446655440000")}`
          }
        });
        // if(response.data === true) {
          Swal.fire({
            icon: 'success',
            title: t("change_password.success_title", "Mot de passe changé"),
            text: t("change_password.success_text", "Le mot de passe a été changé avec succès."),
            showConfirmButton: false,
            timer: 2000
          });
          setLoading(false);
        // }
      } catch (error) {
        console.error("Error creating utilisateur:", error);
        Swal.fire({
          icon: 'error',
          title: t("change_password.error_title", "Erreur"),
          text: t("change_password.error_text", "Une erreur s'est produite lors du changement du mot de passe."),
        });
        setLoading(false);
      }
      // console.log("Form submitted:", values);
      // alert(JSON.stringify(values, null, 2));
      setSubmitting(false);
      resetForm();
    },
  });

  // Pagination logic
  // const totalPages = Math.ceil(assignmentSummary.length / rowsPerPage);
  // const startIndex = (page - 1) * rowsPerPage;
  // const currentTeachers = assignmentSummary.slice(startIndex, startIndex + rowsPerPage);

  // const handlePageChange = (event, value) => {
  //   setPage(value);
  // };
  return (
    <DashboardLayout>
      {loading && <Loading />}
      {/* <Loading /> */}
      <DashboardNavbar />
        <SoftBox py={3} className="content-area-main">
          <Card style={{maxWidth: '550px', margin: '0 auto'}}>
            <SoftBox display="flex" justifyContent="space-between" alignItems="center" p={3} pb={1}>
              <SoftTypography variant="h6">{t("change_password.title", "Changer le mot de passe")}</SoftTypography>
            </SoftBox>
            <form onSubmit={formik.handleSubmit} className='assignment-form'>
              <Grid container spacing={1}>
                <Grid item xs={12} xl={12}>
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                      {t("change_password.current_password", "Mot de passe")}
                  </SoftTypography>
                  <SoftInput type="password" name="currentPassword" value={formik.values.currentPassword} onChange={formik.handleChange} onBlur={formik.handleBlur} />
                  {formik.touched.currentPassword && formik.errors.currentPassword ? (
                    <div className="error-message">
                      {formik.errors.currentPassword}
                    </div>
                  ) : null}
                </Grid>
                <Grid item xs={12} xl={12}>
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                      {t("change_password.new_password", "Confirmez le mot de passe")}
                  </SoftTypography>
                  <SoftInput type="password" name="newPassword" value={formik.values.newPassword} onChange={formik.handleChange} onBlur={formik.handleBlur} />
                  {formik.touched.newPassword && formik.errors.newPassword ? (
                    <div className="error-message">
                      {formik.errors.newPassword}
                    </div>
                  ) : null}
                </Grid>

                <Grid item xs={12} xl={12}>
                  <SoftButton type="submit" variant="gradient" color="info" fullWidth style={{marginTop: '30px'}}>
                    {formik.isSubmitting ? "Loading..." : t("change_password.save", "ENREGISTRER")}
                  </SoftButton>
                </Grid>
              </Grid>
            </form>
          </Card>
        </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ChangePassword;
